export const messages = {
  zh: {
    propertyRightRegistration: {
      search: {
        title: '查询条件',
        roomId: '房屋ID',
        allNum: '房屋编号(楼栋-单元-房屋)',
        name: '姓名',
        link: '联系方式',
        idCard: '身份证号',
        address: '地址',
        state: '审核状态',
        floor: '楼栋',
        unit: '单元'
      },
      list: {
        title: '房屋产权'
      },
      table: {
        prrId: '房屋产权ID',
        roomId: '房屋ID',
        roomNum: '房屋编号',
        name: '姓名',
        link: '联系方式',
        idCard: '身份证号',
        address: '地址',
        state: '状态'
      },
      add: {
        title: '添加产权登记',
        floor: '楼栋',
        floorRequired: '请选择楼栋',
        floorPlaceholder: '请选择楼栋',
        floorUnit: '号楼',
        unit: '单元',
        unitRequired: '请选择单元',
        unitPlaceholder: '请选择单元',
        unitUnit: '单元',
        room: '房屋',
        roomRequired: '请选择房屋',
        roomPlaceholder: '请选择房屋',
        name: '姓名',
        nameRequired: '请输入姓名',
        namePlaceholder: '请输入姓名',
        nameLength: '姓名长度在2到64个字符之间',
        link: '联系方式',
        linkRequired: '请输入联系方式',
        linkPlaceholder: '请输入联系方式',
        idCard: '身份证号',
        idCardRequired: '请输入身份证号',
        idCardPlaceholder: '请输入身份证号',
        idCardFormatError: '身份证格式不正确',
        address: '地址',
        addressRequired: '请输入地址',
        addressPlaceholder: '请输入地址',
        addressMax: '地址长度不能超过255个字符',
        idCardPhotos: '身份证照片',
        idCardPhotosRequired: '请上传身份证照片',
        idCardPhotosTip: '*请上传正反两张身份证照片*',
        housePurchasePhotos: '购房合同照片',
        housePurchasePhotosRequired: '请上传购房合同照片',
        housePurchasePhotosTip: '*请上传不超过十张购房合同图片*',
        isTrue: '维修基金是否缴纳',
        isTrueRequired: '请选择维修基金是否缴纳',
        isTruePlaceholder: '请选择维修基金是否缴纳',
        repairPhotos: '维修基金照片',
        repairPhotosRequired: '请上传维修基金照片',
        flag: '契税是否缴纳',
        flagRequired: '请选择契税是否缴纳',
        flagPlaceholder: '请选择契税是否缴纳',
        deedTaxPhotos: '契税证明照片',
        deedTaxPhotosRequired: '请上传契税证明照片',
        success: '添加成功',
        error: '添加失败'
      },
      edit: {
        title: '修改产权登记',
        floor: '楼栋',
        floorRequired: '请选择楼栋',
        floorPlaceholder: '请选择楼栋',
        floorUnit: '号楼',
        unit: '单元',
        unitRequired: '请选择单元',
        unitPlaceholder: '请选择单元',
        unitUnit: '单元',
        room: '房屋',
        roomRequired: '请选择房屋',
        roomPlaceholder: '请选择房屋',
        name: '姓名',
        nameRequired: '请输入姓名',
        namePlaceholder: '请输入姓名',
        nameLength: '姓名长度在2到64个字符之间',
        link: '联系方式',
        linkRequired: '请输入联系方式',
        linkPlaceholder: '请输入联系方式',
        idCard: '身份证号',
        idCardRequired: '请输入身份证号',
        idCardPlaceholder: '请输入身份证号',
        idCardFormatError: '身份证格式不正确',
        address: '地址',
        addressRequired: '请输入地址',
        addressPlaceholder: '请输入地址',
        addressMax: '地址长度不能超过255个字符',
        success: '修改成功',
        error: '修改失败'
      },
      examine: {
        title: '产权登记审核',
        room: '房屋',
        roomPlaceholder: '房屋信息',
        state: '状态',
        stateRequired: '请选择状态',
        statePlaceholder: '请选择状态',
        remark: '审核意见',
        remarkPlaceholder: '请输入审核意见',
        success: '审核成功',
        error: '审核失败',
        fetchStateError: '获取审核状态失败'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除该房屋产权登记信息吗？',
        tip: '删除后将无法恢复，请谨慎操作！',
        success: '删除成功',
        error: '删除失败'
      },
      fetchError: '获取数据失败'
    },
  },
  en: {
    propertyRightRegistration: {
      search: {
        title: 'Search Conditions',
        roomId: 'Room ID',
        allNum: 'Room Number(Building-Unit-Room)',
        name: 'Name',
        link: 'Contact',
        idCard: 'ID Card',
        address: 'Address',
        state: 'Audit Status',
        floor: 'Building',
        unit: 'Unit'
      },
      list: {
        title: 'Property Right'
      },
      table: {
        prrId: 'Property Right ID',
        roomId: 'Room ID',
        roomNum: 'Room Number',
        name: 'Name',
        link: 'Contact',
        idCard: 'ID Card',
        address: 'Address',
        state: 'Status'
      },
      add: {
        title: 'Add Property Registration',
        floor: 'Building',
        floorRequired: 'Please select building',
        floorPlaceholder: 'Please select building',
        floorUnit: 'Building',
        unit: 'Unit',
        unitRequired: 'Please select unit',
        unitPlaceholder: 'Please select unit',
        unitUnit: 'Unit',
        room: 'Room',
        roomRequired: 'Please select room',
        roomPlaceholder: 'Please select room',
        name: 'Name',
        nameRequired: 'Please enter name',
        namePlaceholder: 'Please enter name',
        nameLength: 'Name length should be between 2 and 64 characters',
        link: 'Contact',
        linkRequired: 'Please enter contact',
        linkPlaceholder: 'Please enter contact',
        idCard: 'ID Card',
        idCardRequired: 'Please enter ID card',
        idCardPlaceholder: 'Please enter ID card',
        idCardFormatError: 'Invalid ID card format',
        address: 'Address',
        addressRequired: 'Please enter address',
        addressPlaceholder: 'Please enter address',
        addressMax: 'Address length cannot exceed 255 characters',
        idCardPhotos: 'ID Card Photos',
        idCardPhotosRequired: 'Please upload ID card photos',
        idCardPhotosTip: '*Please upload front and back photos of ID card*',
        housePurchasePhotos: 'House Purchase Contract Photos',
        housePurchasePhotosRequired: 'Please upload house purchase contract photos',
        housePurchasePhotosTip: '*Please upload up to ten house purchase contract photos*',
        isTrue: 'Maintenance Fund Paid',
        isTrueRequired: 'Please select whether maintenance fund is paid',
        isTruePlaceholder: 'Please select whether maintenance fund is paid',
        repairPhotos: 'Maintenance Fund Photos',
        repairPhotosRequired: 'Please upload maintenance fund photos',
        flag: 'Deed Tax Paid',
        flagRequired: 'Please select whether deed tax is paid',
        flagPlaceholder: 'Please select whether deed tax is paid',
        deedTaxPhotos: 'Deed Tax Certificate Photos',
        deedTaxPhotosRequired: 'Please upload deed tax certificate photos',
        success: 'Added successfully',
        error: 'Failed to add'
      },
      edit: {
        title: 'Edit Property Registration',
        floor: 'Building',
        floorRequired: 'Please select building',
        floorPlaceholder: 'Please select building',
        floorUnit: 'Building',
        unit: 'Unit',
        unitRequired: 'Please select unit',
        unitPlaceholder: 'Please select unit',
        unitUnit: 'Unit',
        room: 'Room',
        roomRequired: 'Please select room',
        roomPlaceholder: 'Please select room',
        name: 'Name',
        nameRequired: 'Please enter name',
        namePlaceholder: 'Please enter name',
        nameLength: 'Name length should be between 2 and 64 characters',
        link: 'Contact',
        linkRequired: 'Please enter contact',
        linkPlaceholder: 'Please enter contact',
        idCard: 'ID Card',
        idCardRequired: 'Please enter ID card',
        idCardPlaceholder: 'Please enter ID card',
        idCardFormatError: 'Invalid ID card format',
        address: 'Address',
        addressRequired: 'Please enter address',
        addressPlaceholder: 'Please enter address',
        addressMax: 'Address length cannot exceed 255 characters',
        success: 'Updated successfully',
        error: 'Failed to update'
      },
      examine: {
        title: 'Property Registration Audit',
        room: 'Room',
        roomPlaceholder: 'Room information',
        state: 'Status',
        stateRequired: 'Please select status',
        statePlaceholder: 'Please select status',
        remark: 'Audit Opinion',
        remarkPlaceholder: 'Please enter audit opinion',
        success: 'Audit successful',
        error: 'Audit failed',
        fetchStateError: 'Failed to get audit status'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this property registration?',
        tip: 'The data cannot be recovered after deletion, please operate carefully!',
        success: 'Deleted successfully',
        error: 'Failed to delete'
      },
fetchError: 'Failed to fetch data'
    }
  },
  'zh-TW': {
    propertyRightRegistration: {
      search: {
        title: '查詢條件',
        roomId: '房屋ID',
        allNum: '房屋編號(樓棟-單元-房屋)',
        name: '姓名',
        link: '聯繫方式',
        idCard: '身份證號',
        address: '地址',
        state: '審核狀態',
        floor: '樓棟',
        unit: '單元'
      },
      list: {
        title: '房屋產權'
      },
      table: {
        prrId: '房屋產權ID',
        roomId: '房屋ID',
        roomNum: '房屋編號',
        name: '姓名',
        link: '聯繫方式',
        idCard: '身份證號',
        address: '地址',
        state: '狀態'
      },
      add: {
        title: '添加產權登記',
        floor: '樓棟',
        floorRequired: '請選擇樓棟',
        floorPlaceholder: '請選擇樓棟',
        floorUnit: '號樓',
        unit: '單元',
        unitRequired: '請選擇單元',
        unitPlaceholder: '請選擇單元',
        unitUnit: '單元',
        room: '房屋',
        roomRequired: '請選擇房屋',
        roomPlaceholder: '請選擇房屋',
        name: '姓名',
        nameRequired: '請輸入姓名',
        namePlaceholder: '請輸入姓名',
        nameLength: '姓名長度在2到64個字符之間',
        link: '聯繫方式',
        linkRequired: '請輸入聯繫方式',
        linkPlaceholder: '請輸入聯繫方式',
        idCard: '身份證號',
        idCardRequired: '請輸入身份證號',
        idCardPlaceholder: '請輸入身份證號',
        idCardFormatError: '身份證格式不正確',
        address: '地址',
        addressRequired: '請輸入地址',
        addressPlaceholder: '請輸入地址',
        addressMax: '地址長度不能超過255個字符',
        idCardPhotos: '身份證照片',
        idCardPhotosRequired: '請上傳身份證照片',
        idCardPhotosTip: '*請上傳正反兩張身份證照片*',
        housePurchasePhotos: '購房合同照片',
        housePurchasePhotosRequired: '請上傳購房合同照片',
        housePurchasePhotosTip: '*請上傳不超過十張購房合同圖片*',
        isTrue: '維修基金是否繳納',
        isTrueRequired: '請選擇維修基金是否繳納',
        isTruePlaceholder: '請選擇維修基金是否繳納',
        repairPhotos: '維修基金照片',
        repairPhotosRequired: '請上傳維修基金照片',
        flag: '契稅是否繳納',
        flagRequired: '請選擇契稅是否繳納',
        flagPlaceholder: '請選擇契稅是否繳納',
        deedTaxPhotos: '契稅證明照片',
        deedTaxPhotosRequired: '請上傳契稅證明照片',
        success: '添加成功',
        error: '添加失敗'
      },
      edit: {
        title: '修改產權登記',
        floor: '樓棟',
        floorRequired: '請選擇樓棟',
        floorPlaceholder: '請選擇樓棟',
        floorUnit: '號樓',
        unit: '單元',
        unitRequired: '請選擇單元',
        unitPlaceholder: '請選擇單元',
        unitUnit: '單元',
        room: '房屋',
        roomRequired: '請選擇房屋',
        roomPlaceholder: '請選擇房屋',
        name: '姓名',
        nameRequired: '請輸入姓名',
        namePlaceholder: '請輸入姓名',
        nameLength: '姓名長度在2到64個字符之間',
        link: '聯繫方式',
        linkRequired: '請輸入聯繫方式',
        linkPlaceholder: '請輸入聯繫方式',
        idCard: '身份證號',
        idCardRequired: '請輸入身份證號',
        idCardPlaceholder: '請輸入身份證號',
        idCardFormatError: '身份證格式不正確',
        address: '地址',
        addressRequired: '請輸入地址',
        addressPlaceholder: '請輸入地址',
        addressMax: '地址長度不能超過255個字符',
        success: '修改成功',
        error: '修改失敗'
      },
      examine: {
        title: '產權登記審核',
        room: '房屋',
        roomPlaceholder: '房屋信息',
        state: '狀態',
        stateRequired: '請選擇狀態',
        statePlaceholder: '請選擇狀態',
        remark: '審核意見',
        remarkPlaceholder: '請輸入審核意見',
        success: '審核成功',
        error: '審核失敗',
        fetchStateError: '獲取審核狀態失敗'
      },
      delete: {
        title: '刪除確認',
        confirm: '確定刪除該房屋產權登記信息嗎？',
        tip: '刪除後將無法恢復，請謹慎操作！',
        success: '刪除成功',
        error: '刪除失敗'
      },
      fetchError: '獲取數據失敗'
    },
  }
}